'use strict';

function _EditEmployment() {
  this.node = null;
  this.id = null;
  this.declaredClass = null;
  this.extends = [EditData, _ErrorController];
  this.analytics = new Analytics();
  this.dataSanitization = new DataSanitization();

  this.init = function () {
    this._super();

    $('.js-editData__edit-icon', this.node).on('click.editSection', this.onEditSection.bind(this, this.setYearsEmployedToModel.bind(this)));
  };

  this.initAllReady = function () {
    this._super();

    // this Page component is loaded inline via Pug, and is used on 2 diff pages...
    // in the case when page A redirects to page B, we have timing issues with init and destroy of the same component...
    // so this guard prevents running things twice
    var empForm = $('[data-mogo-page="_EditEmployment"]');
    if (empForm.length === 1) {
      this._editEmploymentCallback = this.presenter.addCallbackToAction('account.edit_employment_info', $.proxy(this._onEditEmployment, this));
      this._addComputedVariablesToSummary();

      this._setupForm();

      $(this.node).show();
    }
  };

  this.toggleMonthsEmployed = function (e) {
    var value = e.target.value;

    if (value == 10) {
      this.months_employed_container_el.hide();
      this.timeEmployedAmp.hide();
      this.months_employed_el.mogo().setSelectedIndex(1);
    } else {
      this.months_employed_container_el.show();
      this.timeEmployedAmp.show();
    }
    if (this.months_employed_el.hasClass('error')) {
      this.months_employed_el.removeClass('error');
      this.months_employed_el.parents('.mogo-ui-select').removeClass('error');
    }
  };
  this._prehook = function () {
    var path = null;
    this.form_el.mogo().removeAllValidationPaths();

    switch (this.employment_type_el.mogo().val()) {
      case 'Employed':
      case 'Maternity Leave':
        var status = this.salary_type_el.mogo().val();
        if (status) status = status[0];
        switch (status) {
          case 'Hourly':
            path = '#/oneOf/0';
            break;
          case 'Salary':
            path = '#/oneOf/1';
            break;
          default:
            path = '#/oneOf/0';
            break;
        }
        break;
      case 'Unemployed':
      case 'Homemaker':
        path = '#/oneOf/2';
        break;
      case 'Pension':
      case 'Disability':
        path = '#/oneOf/3';
        break;

      case 'Self-Employed':
        path = '#/oneOf/4';
        break;
    }

    if (path) this.form_el.mogo().addValidationIncludePath(path);
  };

  this._extendPresenter = function () {
    this.presenter.extendCustomValidations('account.edit_employment_info', {
      _hooks: { prehook: this._prehook.bind(this) },
      years_employed: {
        sanitize: function sanitize() {}
      },
      months_employed: {
        sanitize: function (value) {
          var returnVal = null;
          var years = 0;
          var yearsInMonths = 0;
          var months = 0;
          var hasSelectedYearsVal = this.years_employed_el.val() && !isNaN(this.years_employed_el.val());
          var hasSelectedMonthsVal = !isNaN(value);
          var hasSelected1orMoreMonths = false;
          var hasSelected1orMoreYears = false;

          if (hasSelectedYearsVal) {
            years = this.years_employed_el.val();
            yearsInMonths = parseInt(years) * 12;
            hasSelected1orMoreYears = yearsInMonths > 0;
          }

          if (hasSelectedMonthsVal) {
            months = parseInt(value);
            hasSelected1orMoreMonths = months > 0;
          }

          if (!hasSelectedMonthsVal && hasSelected1orMoreYears) {
            // no months, has years
            // = months validation passes
            returnVal = yearsInMonths;
          } else if (!hasSelected1orMoreMonths && !hasSelected1orMoreYears) {
            // no months, no years
            // = months validation fails
            return;
          } else if (hasSelected1orMoreMonths && !hasSelected1orMoreYears) {
            // has months, no years
            // = months validation passes
            returnVal = months;
          } else if (hasSelectedMonthsVal && hasSelected1orMoreYears) {
            // has months, has years
            // = months validation passes
            returnVal = yearsInMonths + months;
          }
          return returnVal;
        }.bind(this)
      },
      gross_annual_income: {
        sanitize: function sanitize(value) {
          if (value > 1) {
            return value;
          }
        }
      },
      average_paycheck_amount: {
        sanitize: function sanitize(value) {
          if (value > 1) {
            return value;
          }
        }
      }
    });
  };
  this._setupForm = function (e) {
    // elements
    this.form_el = $('form', this.node);
    this.years_employed_el = $('#years_employed', this.node);
    this.salary_type_el = $('#salary_type', this.node);
    this.gross_annual_income_el = $('#gross_annual_income', this.node);
    this.average_paycheck_amount_el = $('#average_paycheck_amount', this.node);
    this.salary_frequency_el = $('#salary_frequency', this.node);
    this.months_employed_el = $('#months_employed', this.node);
    this.months_employed_container_el = this.months_employed_el.parents('.input__container');
    this.time_employed_amp_el = this.months_employed_container_el.prev();
    this.timeEmployedAmp = $('.js--time-employed-seperator', this.node);
    this.employment_type_el = $('#employment_type', this.node);

    $('.js-cancel', this.node).on('click.cancelEdits', this.cancelEdits.bind(this, 'account', this._triggerEmploymentChange.bind(this)));
    this.employment_type_el.on('change', this.toggleEmploymentType.bind(this));
    $('#salary_type input', this.node).on('change click', this.toggleSalaryType.bind(this));
    this.years_employed_el.on('change', this.toggleMonthsEmployed.bind(this));

    this._extendPresenter();
    this._extendViewMap();
    this.presenter.scanDOM(this.node);
    this._triggerEmploymentChange();
  };

  this._addComputedVariablesToSummary = function () {
    // display data in summary
    this.presenter.addComputedVariable('average_paycheck_amount_display', ['account.average_paycheck_amount'], function (average_paycheck_amount) {
      if (average_paycheck_amount) {
        return Formatters.formatMoney(average_paycheck_amount, { optionalDecimals: true });
      }
    });
    this.presenter.addComputedVariable('gross_annual_income_display', ['account.gross_annual_income'], function (gross_annual_income) {
      if (gross_annual_income) return Formatters.formatMoney(gross_annual_income, { optionalDecimals: true });
    });
    this.presenter.addComputedVariable('salary_frequency_display', ['account.salary_frequency'], function (salary_frequency) {
      switch (salary_frequency) {
        case 'bi_weekly':
          return 'bi-weekly';
          break;
        case 'semi_monthly':
          return 'semi-monthly';
          break;
        default:
          return salary_frequency;
      }
    });
    this.presenter.addComputedVariable('years_employed_display', ['account.months_employed'], function (months_employed) {
      var years = Math.floor(months_employed / 12);
      var months = months_employed % 12;
      var formatPluralTimeframe = function formatPluralTimeframe(val, string) {
        var result = void 0;
        switch (val) {
          case 0:
            result = '';
            break;
          case 1:
            result = val + string;
            break;
          default:
            result = val + string + 's';
        }
        return result;
      };
      var yearsFormatted = formatPluralTimeframe(years, ' year');
      var monthsFormatted = formatPluralTimeframe(months, ' month');
      return ' ' + yearsFormatted + ' ' + monthsFormatted + ' ';
    });
  };

  this._extendViewMap = function () {
    var viewMap = {
      'account.months_employed': {
        get: function get(value) {
          if (value == '' || value == null) {
            // initial hard load value is null and we dont want it set to 0
            return false;
          }
          var months = value % 12;
          return months.toString();
        },

        set: function (value) {
          if (this.years_employed_el.val() != null) {
            var yearsToMonths = parseInt(this.years_employed_el.val()) * 12;

            var useMonths = null;
            if (isNaN(value)) {
              useMonths = 0;
            } else {
              useMonths = parseInt(value);
            }
            value = yearsToMonths + useMonths;
            return Number(value);
          }
          if (this.months_employed_el.val() == null) {
            return value;
          }
          return Number(value);
        }.bind(this)
      }
    };

    this.presenter.extendViewMap(viewMap);
  };

  this.setYearsEmployedToModel = function () {
    this.presenter.models.account.years_employed = Math.floor(this.presenter.models.account.months_employed / 12);
    this.presenter.updateDOM(this.node);
  };

  this.toggleEmploymentType = function (e) {
    var employmentType = e.target.value.toLowerCase();
    switch (employmentType) {
      case 'employed':
      case 'maternity leave':
        this.showEmployedAndMaternityOptions();
        break;
      case 'pension':
      case 'disability':
        this.showPensionAndDisabilityOptions();
        break;
      case 'unemployed':
        this.showUnemployedOptions();
        break;
      case 'self-employed':
        this.showSelfEmployedOptions();
        break;
      default:
        this.showUnemployedOptions();
        return false;
    }
  };

  this.showSelfEmployedOptions = function () {
    $('.possible-employment-option, .possible-option', this.node).hide();
    $('.js--employment-length', this.node).show();
    $('#salary-option.possible-option', this.node).show();
    this.gross_annual_income_el.mogo().$placeholder.text('Gross annual income (personal)');
    this.resetFields([this.salary_type_el, this.average_paycheck_amount_el, this.salary_frequency_el]);
  };

  this.showEmployedAndMaternityOptions = function () {
    // Display All fields
    $('.possible-employment-option', this.node).show();
    $('#hourly-option, #salary-option', this.node).hide();
    this.gross_annual_income_el.mogo().$placeholder.text('Gross annual income');

    // show rest only if previously selected
    if ($('.hourly').is(':checked')) {
      this.setSalaryType('hourly');
    } else if ($('.salary').is(':checked')) {
      this.setSalaryType('salary');
    }
  };

  this.showPensionAndDisabilityOptions = function () {
    // Display Average Payment & Frequency Fields
    $('.possible-employment-option, #salary-option.possible-option', this.node).hide();
    $('#hourly-option.possible-option', this.node).show();
    this.resetFields([this.gross_annual_income_el, this.years_employed_el, this.months_employed_el, this.salary_type_el]);
  };

  this.showUnemployedOptions = function () {
    // Display No fields
    $('.possible-employment-option, .possible-option', this.node).hide();
    this.resetFields([this.years_employed_el, this.months_employed_el, this.salary_type_el, this.gross_annual_income_el, this.average_paycheck_amount_el, this.salary_frequency_el]);
  };

  this.setSalaryType = function (type) {
    $('.possible-option', this.node).hide();
    $('#' + type + '-option', this.node).show();
    if (type == 'hourly') {
      this.resetFields([this.gross_annual_income_el]);
    } else {
      this.resetFields([this.average_paycheck_amount_el, this.salary_frequency_el]);
    }
  };

  this.toggleSalaryType = function (e) {
    var value = e.target.value.toLowerCase();
    $('.possible-option', this.node).hide();
    $('#' + value + '-option', this.node).show();
    if (value == 'hourly') {
      this.resetFields([this.gross_annual_income_el]);
    } else {
      this.resetFields([this.average_paycheck_amount_el, this.salary_frequency_el]);
    }
  };

  this.resetFields = function (fieldArr) {
    for (var i = 0; i < fieldArr.length; i++) {
      var mogoFieldType = fieldArr[i].data('mogo-ui');
      var bind = fieldArr[i].data('bind');
      if (bind) this.presenter.models[bind.split('.')[0]].removeModelProperty(bind.split('.')[1]);
      if (mogoFieldType === 'Select') {
        if (fieldArr[i].val()) fieldArr[i].mogo().setSelectedIndex(0);
      } else if (mogoFieldType === 'BooleanGroup') {
        fieldArr[i].mogo().val(false);
      } else if (fieldArr[i].val()) fieldArr[i].mogo().val('');
    }
  };

  this._triggerEmploymentChange = function () {
    $('#employment_type', this.node).trigger('change');
    this.setYearsEmployedToModel();
  };

  this._onEditEmployment = function (data, response) {
    if (this.isGeneralConnectionIssue(data, response)) {
      this.invokeConnectionIssuePage($('#editEmploymentInfo')[0], { productLabel: 'MogoMember' });
    } else if (response == 200) {
      var formAnalyticsID = $('#editEmploymentInfo').data('analytics-id');
      this.analytics.pushEvent('form-submit', { FormID: [formAnalyticsID] });
      this.presenter.models.account.updateModel(data);
      this.setYearsEmployedToModel();

      var isReviewPage = $('#loanOfferReupReview').length > 0;
      if (isReviewPage) {
        this.closeSection();
        $('#loanOfferReupReview').mogo().stopEditingMode();
      }
    } else {
      $('#Notification').mogo().get();
    }
  };

  this.destroy = function () {
    $('.js-editData__edit-icon', this.node).off('click.editSection');
    $('.js-cancel', this.node).off('click.cancelEdits');
    $('#employment_type', this.node).off('change', $.proxy(this.toggleEmploymentType, this));
    $('#salary_type input', this.node).off('change click', $.proxy(this.toggleSalaryType, this));
    this.presenter.removeComputedVariable('average_paycheck_amount_display');
    this.presenter.removeComputedVariable('gross_annual_income_display');
    this.presenter.removeComputedVariable('salary_frequency_display');
    this.presenter.removeComputedVariable('years_employed_display');
    this.presenter.removeCallbackFromAction('account.edit_employment_info', this._editEmploymentCallback);
  };
}